// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Link$Showside from "./Link.bs.js";
import * as IconNext$Showside from "../icons/IconNext.bs.js";
import * as StringUtils$Showside from "../utils/StringUtils.bs.js";
import * as DynamicTruncate$Showside from "./DynamicTruncate.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function LastCard(Props) {
  var href = Props.href;
  var title = Props.title;
  var linkLabel = Props.linkLabel;
  var shape = Props.shape;
  var icon = Props.icon;
  var isListItemOpt = Props.isListItem;
  var onClick = Props.onClick;
  var isListItem = isListItemOpt !== undefined ? isListItemOpt : false;
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var settings = match.settings;
  ViewportContext$Showside.use(undefined);
  var linkLabel$1 = Belt_Option.getWithDefault(linkLabel, settings.openLinkLabel);
  var openLinkInNewTab = settings.openLinkInNewTab;
  var aspectRatioCn;
  if (typeof shape === "number") {
    switch (shape) {
      case /* Circle */0:
      case /* Square */1:
        aspectRatioCn = "aspect-ratio-square";
        break;
      case /* Landscape */2:
        aspectRatioCn = "aspect-ratio-4/3";
        break;
      case /* Portrait */3:
        aspectRatioCn = "aspect-ratio-2/3";
        break;
      case /* Panorama */4:
        aspectRatioCn = "aspect-ratio-21/9";
        break;
      case /* Wide */5:
        aspectRatioCn = "aspect-ratio-16/9";
        break;
      case /* Tall */6:
        aspectRatioCn = "aspect-ratio-9/16";
        break;
    }
  } else {
    aspectRatioCn = "";
  }
  var aspectRatioStyle = typeof shape === "number" ? undefined : {
    paddingBottom: CSS$Showside.floatToPercentage(shape._1 / shape._0 * 100.0)
  };
  var aspectRatioCn$1 = isListItem ? "" : aspectRatioCn;
  var aspectRatioStyle$1 = isListItem ? undefined : aspectRatioStyle;
  var flexDirCn = isListItem ? "flex-row-reverse space-x-reverse" : "flex-col";
  var heightCn = isListItem ? "h-14" : "h-0";
  var positionCn = isListItem ? "relative" : "absolute";
  var spaceBetweenCn = isListItem ? "space-x-2" : "space-y-4";
  var textPaddingCn = isListItem ? "" : "px-6";
  var textAlignmentCn = isListItem ? "text-left" : "text-center";
  var paddingCn = isListItem ? "px-4" : "";
  var arrow = React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make([isListItem ? "w-8 h-8" : "w-12 h-12", "block rounded-full flex items-center justify-center overflow-hidden relative flex-shrink-0"]))
  }, isListItem ? null : React.createElement("div", {
    className: CSS$Showside.prefix("absolute inset-0 opacity-10 group-2-hover:opacity-25 bg-tertiary")
  }), Belt_Option.getWithDefault(icon, React.createElement(IconNext$Showside.make, {
    className: CSS$Showside.prefix(Cn.make([isListItem ? "h-4" : "h-5 relative left-px", "text-primary"])),
    strokeWidth: "4"
  })));
  var tmp = {
    children: null,
    unstyled: true,
    className: CSS$Showside.prefix(Cn.make(["flex cursor-pointer justify-center no-underline relative overflow-hidden transform-gpu no-touch-highlight group-2", heightCn, aspectRatioCn$1, "rounded-custom", paddingCn])),
    openLinkInNewTab: openLinkInNewTab
  };
  if (href !== undefined) {
    tmp.href = Caml_option.valFromOption(href);
  }
  if (aspectRatioStyle$1 !== undefined) {
    tmp.style = Caml_option.valFromOption(aspectRatioStyle$1);
  }
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  return React.createElement("div", undefined, React.createElement(Link$Showside.make, tmp, React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["absolute inset-0 opacity-10 group-2-hover:opacity-25", "bg-tertiary"]))
  }), React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["inset-0 flex items-center justify-center text-primary rounded-inherit font-semibold transform-gpu text-lg", positionCn, flexDirCn, spaceBetweenCn]))
  }, arrow, React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make([textAlignmentCn, textPaddingCn]))
  }, React.createElement(DynamicTruncate$Showside.make, {
    lines: 2,
    children: StringUtils$Showside.concatWithoutRepeat(linkLabel$1, title)
  })))));
}
LastCard.displayName = "LastCard";
var make = LastCard;
export { make };
/* react Not a pure module */